import React, { useState } from "react";
import Button from "../../../Components/Common/Button";
import Input from "../../../Components/Common/Input";
import useSWRMutation from "swr/mutation";
import { AuthUrls } from "../../../Api/Auth/ApiUrls";
import { sendPostRequest } from "../../../Api/swrConfig";
import { toast } from "react-toastify";
import useToastError from "../../../hooks/useErrorToast";
import { Link, useNavigate } from "react-router-dom";
import { Loader } from "../../../Components/Common/Loader";
import { useAuth } from "../../../Context/AuthContext";
import { dashboardUrls, downloadableMaterial } from "../../../Api/Auth/AppUrls";

const LoginForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const { showErrorToast } = useToastError();
  const { setUserData, setToken } = useAuth();
  // SWR mutation hook to handle the form submission login
  const { trigger, isMutating } = useSWRMutation(
    AuthUrls.login,
    sendPostRequest,
    {
      onSuccess: (data) => {
        toast.success("Success");
        localStorage.setItem("authToken", data?.token);
        setToken(data?.token);
        setUserData(data?.userData);
        data?.userData?.roleId === 2
          ? navigate(dashboardUrls.student)
          : data?.userData?.roleId === 6
          ? navigate(downloadableMaterial.adminFreeModelTest)
          : navigate(dashboardUrls.admin);
      },
      onError: (error) => {
        console.log(error);

        showErrorToast(error);
        // console.log(error);
      },
    }
  );

  // SWR mutation hook to handle the form submission reset email
  const { trigger: triggerEmail, isMutating: emailMutating } = useSWRMutation(
    AuthUrls.forgotPassword,
    sendPostRequest,
    {
      onSuccess: () => {
        toast.success("Success");
        navigate("/reset-password");
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple validation
    const validationErrors = {};
    if (!formData.email) validationErrors.email = "Email is required.";
    if (!formData.password) validationErrors.password = "Password is required.";
    setErrors(validationErrors);

    // Handle form submission if there are no errors
    if (Object.keys(validationErrors).length !== 0) {
      return;
    }
    trigger(formData);
  };

  const sendResetEmail = () => {
    const validationErrors = {};
    if (!formData.email) validationErrors.email = "Email is required.";
    setErrors(validationErrors);
    // Handle form submission if there are no errors
    if (Object.keys(validationErrors).length !== 0) {
      return;
    }
    triggerEmail({ email: formData.email });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="font-regular">Enter your credentials below to login</h2>

      {/* Email Field */}

      <Input
        label="Email"
        type="email"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        placeholder="Enter your email"
        error={errors.email}
        required
      />

      {/* Password Field */}

      <Input
        label="Password"
        type="password"
        name="password"
        value={formData.password}
        onChange={handleInputChange}
        placeholder="Enter your password"
        error={errors.password}
        required
      />

      {/* Submit Button */}
      {emailMutating ? (
        <Loader />
      ) : (
        <p
          className="text-sm underline cursor-pointer"
          onClick={() => sendResetEmail()}
        >
          Forgot Password?
        </p>
      )}
      <div className="flex items-center gap-4">
        <Button type="primary" isLoading={isMutating}>
          Login
        </Button>
        <Link to="/register">
          <Button type="outline">Register</Button>
        </Link>
      </div>
    </form>
  );
};

export default LoginForm;
